<template>
	<div class="resources">
		<Nav />
		<span class="overlay" :class="{active: isMenuOpen}"></span>
		<div class="header header-standard">
			<HeaderNavBar back survey searchType="resources"/>
		</div><!-- header -->
		<div class="header-image lblue"></div><!-- header image -->
		<div class="content-wrap content-wrap-alt content-wrap-nav">
			<div class="has-split">
				<SectionTitle
					icon="ChartIcon"
					title="Our Reports"
					colour="lblue"
				/>
				<img width="90" class="shi-logo" alt="The Seafarers Happiness Index" src="@/assets/shi-logo.png" />
			</div>
			<div v-for="(yearReports, year) in reports" :key="year" class="section-gap flex">
				<span class="report-sub">{{ year }}</span>
				<ReportRow
                    v-for="report in yearReports"
                    :key="report.id"
					routeName="SurveyReport"
	                :id="report.id"
					class="card-row-block-resources card-row-block-alt card-row-block-report full"
					:title="'Q' + report.quarter + ' ' + report.year"
					:score="parseFloat(report.score)"
				/>
			</div>
		</div>
		<Menu />
	</div>
</template>
<script>
	import HeaderNavBar from '@/components/HeaderNavBar.vue';
	import Nav from '@/components/Nav.vue';
	import Menu from '@/components/Menu.vue';
	import ReportRow from '@/components/ReportRow.vue';
	import SectionTitle from '@/components/SectionTitle.vue';
    import SurveyService from '@/services/SurveyService';
	export default {
		name: 'SurveyReports',
		components: {
			Nav,
			HeaderNavBar,
			Menu,
			SectionTitle,
			ReportRow
		},
		data () {
	        return {
                reports: []
	        };
	    },
	    methods: {
	    	getReports () {
                return SurveyService.getReports().then((response) => {
                    this.reports = response.data;
                });
            }
	    },
	    computed: {
			isMenuOpen () {
	            return this.$store.state.isMenuOpen;
	        }
		},
		mounted () {
            this.getReports();
        }
	};
</script>
<style scoped lang="scss">
	@import "@/assets/scss/_variables.scss";
	@mixin max_width($breakpoint) {
	    @media only screen and (max-width: $breakpoint) { @content; }
	}
	.flex {
		display: flex;
		flex-wrap: wrap;
	}
	.has-split {
		display: flex;
		justify-content: space-between;
		align-items: center;
		@include max_width(380px) {
			align-items: flex-start;
		}
		.shi-logo {
			margin-left: 15px;
			@include max_width(380px) {
				width: 85px;
			}
		}
	}
	.section-gap {
		.card-row-block-report.full {
			margin-bottom: 17px;
			&:last-of-type {
				margin-bottom: 0;
			}
		}
	}
</style>
